export default {
  'accessLog.title': 'Gestionar Registros de Acceso',
  'accessLog.operationType.login': 'Inicio de sesión',
  'accessLog.operationType.logout': 'Cierre de sesión',
  'accessLog.operationType.refreshCredentials': 'Actualizar credenciales',
  'accessLog.form.operationType': 'Tipo de Operación',
  'accessLog.accessType.mixed': 'Mixto',
  'accessLog.accessType.userAndPassword': 'Usuario y contraseña',
  'accessLog.accessType.office365': 'Office365',
  'accessLog.accessType.google': 'Google',
  'accessLog.accessType.automy': 'AUTOMY',
  'accessLog.text.accessType': 'Tipo de acceso',
  'accessLog.text.isSuccessfulOperation': '¿Operación Satisfactoria?',
  'accessLog.text.ip': 'Ip',
  'accessLog.text.appClient': 'Cliente',
  'accessLog.text.observations': 'Observaciones',
  'accessLog.text.country': 'País',
  'accessLog.text.city': 'Ciudad',
  'accessLog.text.state': 'Estado',
  'accessLog.text.userAgent': 'Agente',
  'accessLog.text.app': 'App',
  'accessLog.text.portal': 'Portal',
  'accessLog.text.accessPolicyId': 'Id de política de acceso',
  'accessLog.text.accessPolicyName': 'Nombre de política de acceso',
  'accessLog.text.accessPolicyEffect': 'Efecto de política de acceso',
  'accessLog.text.accessPolicyDecision': 'Decisión de política de acceso',
  'accessLog.accessPolicyDecision.noMatch': 'Sin coincidencia',
  'accessLog.accessPolicyDecision.matchedDeny': 'Coincide — denegar',
  'accessLog.accessPolicyDecision.matchedAllow': 'Coincide — permitir',
  'accessLog.text.accessPolicyMatchedPath': 'Ruta coincidente de política de acceso',
  'accessLog.text.accessPolicyEvaluation': 'Evaluación de política de acceso',
};
